import { buildTeamLogoOptions, getDefaultValue, getTeamLogoUrlByTeamId } from '@draftkings/sportsbook-common-utils';
import { TeamLogoOptions, Participant } from '@draftkings/sportsbook-common-contracts';

export const getTeamLogo = (
    staticS3Host: string,
    logoUrl: string | undefined,
    swooshBaseUrl: string,
    participant?: Participant,
    isSwooshTeamLogosEnabledForEventPage?: boolean
): string => {
    const options: TeamLogoOptions = buildTeamLogoOptions('md', 'dark', participant?.venueRole);
    const teamId = participant?.metadata?.rosettaTeamId || participant?.id;

    return isSwooshTeamLogosEnabledForEventPage
        ? getDefaultValue(getTeamLogoUrlByTeamId(swooshBaseUrl, teamId, options)?.toString(), '')
        : `${staticS3Host}${logoUrl}`;
};
